module.exports = __webpack_public_path__ + "static/fonts/nucleo-icons.ff208b8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nucleo-icons.woff2
// module id = 8+xR
// module chunks = 4